const events_es = require('./events.json')
export default events_es